// This rename this file to 'env.js' 
// and tweak for your local dev environment
export default {
	ip: '192.168.1.110', // home
	// ip: '192.168.88.16', // office
	// ip: 'localhost',
};